import api from './api';

//新增落地页
export const postAddPageCreate = params => {
  return api("post", "/v1/management/h5-landing-page/landingPageCreate", params);
}

//落地页详情
export const getLandingPage = id => {
  return api("get", `/v1/management/h5-landing-page/landingPageDetails/${id}`);
}

//落地页列表
export const postLandingPageList = params => {
  return api("post", "/v1/management/h5-landing-page/landingPageList", params);
}

//编辑落地页
export const postLandingPageUpdate = params => {
  return api("post", "/v1/management/h5-landing-page/landingPageUpdate", params);
}